import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CompanyDocumentDetailDTO, CompanyDocumentDTO, DocumentTypeDTO, RegisterCompanyDocumentRequestDTO, RegisterCompanyDocumentResponseDTO } from "../interface/company-document.interface";
import { environment } from "src/environments/enviroments";
import { ActionResponseDTO } from "src/app/common/interfaces/action-result.interface";

@Injectable({
    providedIn: 'root'
})
export class CompanyDocumentsService {
    constructor(private httpClient: HttpClient) {

    }

    getCompanyDocuments(companyId: number, documentTypeId: number | null = null): Observable<CompanyDocumentDTO[]> {
        const endpoint = `${environment.apiUrl}/Company/${companyId}/documents?documentTypeId=${documentTypeId||''}`;
        return this.httpClient.get<CompanyDocumentDTO[]>(endpoint);
    }

    getDocumentTypes(): Observable<DocumentTypeDTO[]> {
        const endpoint = `${environment.apiUrl}/Company/DocumentTypes`;
        return this.httpClient.get<DocumentTypeDTO[]>(endpoint);
    }

    uploadCompanyDocument(companyId: number, request: RegisterCompanyDocumentRequestDTO, overwrite: boolean = false): Observable<ActionResponseDTO<RegisterCompanyDocumentResponseDTO>> {
        let data = new FormData();
        data.append('UploadFile', request.uploadFile);
        data.append('DocumentTypeId', request.documentTypeId.toString());
        data.append('Description', request.description || '')
        const endpoint = `${environment.apiUrl}/Company/${companyId}/document/upload?overwrite=${overwrite}`;
        return this.httpClient.post<ActionResponseDTO<RegisterCompanyDocumentResponseDTO>>(endpoint, data);
    }

    getCompanyDocument(companyDocumentId:bigint): Observable<CompanyDocumentDetailDTO>{
        const endpoint = `${environment.apiUrl}/Company/documents/${companyDocumentId}`;
        return this.httpClient.get<CompanyDocumentDetailDTO>(endpoint);
    }

    downloadCompanyDocument(companyDocumentId:bigint){
        const endpoint = `${environment.apiUrl}/Company/documents/${companyDocumentId}/download`;
        return this.httpClient.get(endpoint, {responseType: 'blob'});
    }

    deleteCompanyDocument(companyDocumentId:bigint): Observable<ActionResponseDTO<bigint | null>> {
        const endpoint = `${environment.apiUrl}/Company/documents/${companyDocumentId}`;
        return this.httpClient.delete<ActionResponseDTO<bigint| null>>(endpoint);
    }

    cancelSignCompanyDocument(companyDocumentId:bigint): Observable<ActionResponseDTO<bigint | null>> {
        const endpoint = `${environment.apiUrl}/Company/documents/${companyDocumentId}/cancel-sign`;
        return this.httpClient.put<ActionResponseDTO<bigint| null>>(endpoint, {});
    }

}